import React from 'react';
import {
  Text,
  Modal,
  Button,
  Divider,
  ModalBody,
  ModalHeader,
  ModalContent,
  ModalOverlay,
  ModalCloseButton,
} from 'ui';
import { SelectField, TextAreaField, TextField } from '@components/FormFields';
import { t, tscope } from '@i18n/index';
import { style as s } from './CancelRequisitionModal.style';
import { useController } from './hooks';

export const ts = tscope('Documents.cancelRequisitionModal');

export const CancelRequisitionModal = (props) => {
  const { isOpen, onClose } = props;
  const {
    control,
    onSubmit,
    isLoadingCancel,
    displayReasonField,
    cancellingReasonOptions,
  } = useController({ onClose });

  return (
    <Modal
      size="sm"
      isCentered
      isOpen={isOpen}
      onClose={onClose}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <Text {...s.title}>
            {ts('title')}
          </Text>
        </ModalHeader>
        <ModalCloseButton />
        <Divider />
        <ModalBody {...s.body} as="form" onSubmit={onSubmit}>
          <Text {...s.centerText}>
            {ts('body')}
          </Text>
          <SelectField
            control={control}
            autoFocus
            name="reason"
            labelText={ts('reason')}
            placeholder={t('Common.na')}
            isDisabled={!cancellingReasonOptions || isLoadingCancel}
            data-testid="reason"
          >
            {cancellingReasonOptions?.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </SelectField>
          {displayReasonField && (
            <TextAreaField
              name="reasonDetails"
              control={control}
              borderRadius="xl"
              labelText={ts('reasonDetails')}
              isDisabled={isLoadingCancel}
              data-testid="reasonDetails"
            />
          )}
          <TextField
            id="password"
            control={control}
            name="password"
            type="password"
            labelText={ts('confirm')}
            placeholder={ts('placeholder')}
            data-testid="password"
            isDisabled={isLoadingCancel}
          />
          <Button
            {...s.button}
            type="submit"
            colorScheme="red"
            isDisabled={isLoadingCancel}
          >
            {ts('submit')}
          </Button>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
